import mock from "../mock"
export let departmentsList = [
  {
    id: 1,
    active_status: true,
    name: "Reservation",
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 2,
    active_status: false,
    name: "House Keeping",
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 3,
    active_status: true,
    name: "Accounts",
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 4,
    active_status: false,
    name: "Land Trasportation",
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 5,
    active_status: true,
    name: "Boat Transportation",
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 6,
    active_status: false,
    name: "Restaurants",
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 7,
    active_status: true,
    name: "Reception",
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 8,
    active_status: false,
    name: "Event Management",
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 9,
    active_status: true,
    name: "F&B",
    desc: "Lorem ipsum doler sit amith"
  },
  {
    id: 10,
    active_status: false,
    name: "Activities",
    desc: "Lorem ipsum doler sit amith"
  },
]

// GET DATA
mock.onGet("/api/departmentsList/initial-data").reply(response => {
  return [200, departmentsList]
})

mock.onGet("/api/departmentsList/data").reply(response => {
  let { page, perPage } = response  
  let totalPages = Math.ceil(departmentsList.length / perPage)
  if (page !== undefined && perPage !== undefined) {
    let calculatedPage = (page - 1) * perPage    
    let calculatedPerPage = page * perPage
    return [
      200,
      { data: departmentsList.slice(calculatedPage, calculatedPerPage), totalPages }
    ]
  } else {
    return [
      200,
      { data: departmentsList.slice(0, 10), totalPages: Math.ceil(departmentsList.length / 10) }
    ]
  }
})

// UPDATE DATA
mock.onPost("/api/departmentsList/update-data").reply(request => {
  //let data = JSON.parse(request.data).obj
  departmentsList.map(item => {
    return item    
  })
  return [200]
})

// Add DATA
mock.onPost("/api/departmentsList/add-data").reply(request => {
  let data = JSON.parse(request.data).obj
  let highestId = Math.max.apply(
    Math,
    departmentsList.map(i => i.id)
  )
  departmentsList.unshift({
    ...data,
    id: highestId + 1,
    
  })
  return [200]
})

// DELETE DATA
mock.onPost("/api/departmentsList/delete-data").reply(request => {
  let data = JSON.parse(request.data).obj
  let index = departmentsList.findIndex(item => item.id === data.id)
  departmentsList.splice(index, 1)
  return [200]
})

// DELETE SELECTED DATA
mock.onPost("/api/departmentsList/delete-selected").reply(request => {
  let data = JSON.parse(request.data).arr
  let reducedArray
  ;[departmentsList, data].reduce((a, b) => {
    let c = b.map(j => j.id)
    return (reducedArray = a.filter(i => !c.includes(i.id)))
  })
  departmentsList = reducedArray
  return [200]
})
